export default {
  title: null,
  text: null,
  information: null,
  create: null,
  createText: null,
  breadcrumb: [],
  searchField: 0
}
